riot.tag2('counter-label', '<p class="h2">{this.opts.label}: {this.opts.value}</p>', '', '', function(opts) {
});


// WEBPACK FOOTER //
// ./src/riot/tags/counter-label.tag